define('SuiteDynamics.PLPPromoBanner.ItemCellPromoBanner',
	[
		'item_cell_promo_banner.tpl',
		'underscore',
		'jQuery',
		'Profile.Model',
		'SC.Configuration',
		'Facets.Browse.View',
		'Facets.ItemCell.View',
		'Item.Model'
	],
	function (
		item_cell_promo_banner_tpl,
		_,
		jQuery,
		ProfileModel,
		SCConfiguration,
		FacetsBrowseView,
		FacetsItemCellView,
		ItemModel
	)
{
	'use strict';

	function getPlpPromoBannerConfig() {
		var profileModel = ProfileModel.getInstance();
		var isB2B = false;
		var isLoggedIn = profileModel.get('isLoggedIn') === 'T';

		if (isLoggedIn) {
			var profileCustomFields = profileModel.get('customfields') || [];
			var isB2BField = _.findWhere(profileCustomFields, { name: 'custentity_ano_is_b2b' });
			if (isB2BField && isB2BField.value === 'T') {
				isB2B = true;
			}
		}

		return isB2B ? SCConfiguration.get('plpPromoBanner.categoryPromoBannerB2B') : SCConfiguration.get('plpPromoBanner.categoryPromoBanner');
	}

	function applyMaxHeightToPromoImage() {
		var columns = document.querySelectorAll('[class^="facets-items-collection-view-cell-span"]');
		if (!columns || !columns.length) return;
		var firstColumnImage = columns[0].querySelector('.item-cell-promo-banner-image');
		var maxHeight = 0;

		for (var i = 1; i < columns.length; i++) {
			var gridElement = columns[i].querySelector('.facets-item-cell-grid');
			if (gridElement) {
				var gridHeight = gridElement.getBoundingClientRect().height;
				if (gridHeight > maxHeight) {
					maxHeight = gridHeight;
				}
			}
		}

		if (firstColumnImage) {
			firstColumnImage.style.height = maxHeight + 'px';
			firstColumnImage.style.objectFit = 'contain';
		}
	}

	FacetsBrowseView.prototype.initialize = _.wrap(FacetsBrowseView.prototype.initialize, function(originalFn) {
		originalFn.apply(this, _.toArray(arguments).slice(1));

		var layout = this.options.application.getLayout();
		layout.once('afterAppendView', function() {
			jQuery(window).on('resize', applyMaxHeightToPromoImage);
		});

		window.onload = applyMaxHeightToPromoImage;
	});

	FacetsBrowseView.prototype.beforeShowContent = _.wrap(FacetsBrowseView.prototype.beforeShowContent, function(originalFn) {
		var promise = originalFn.apply(this, _.toArray(arguments).slice(1));
		var self = this;

		if (this.translator.getOptionValue('page') > 1) {
			return promise;
		}

		if (this.isCategoryPage) {
			var deferred = jQuery.Deferred();
			var plpPromoBannerConfig = getPlpPromoBannerConfig();

			if (plpPromoBannerConfig) {
				promise.done(function() {
					var categoryId = self.model.get('category').get('internalid');
					var categoryConfig = _.findWhere(plpPromoBannerConfig, { categoryId: categoryId });

					if (categoryConfig) {
						self.addPromoBannerItem(categoryConfig);
					}

					deferred.resolve();
				});
			} else {
				deferred.resolve();
			}

			return deferred;
		}

		return promise;
	});

	FacetsBrowseView.prototype.addPromoBannerItem = function(categoryConfig) {
		var promoBannerImageUrl = categoryConfig.promoBlockImageUrl;
		var promoBlockImageLinkUrl = categoryConfig.promoBlockImageLinkUrl;
		var promoBannerImageAltText = categoryConfig.promoBannerImageAltText || '';
		var promoBlockImageLinkIsExternal = categoryConfig.promoBlockImageLinkIsExternal;
		var promoBlockImageLinkNewTab = categoryConfig.promoBlockImageLinkNewTab;

		var itemModel = new ItemModel({
			itemId: 'promo-banner',
			isPromoBanner: true,
			promoBannerUrl: promoBannerImageUrl,
			promoBlockImageLinkUrl: promoBlockImageLinkUrl,
			promoBannerImageAltText: promoBannerImageAltText,
			promoBlockImageLinkIsExternal: promoBlockImageLinkIsExternal,
			promoBlockImageLinkNewTab: promoBlockImageLinkNewTab
		});

		this.model.get('items').models.unshift(itemModel);
	};

	FacetsBrowseView.prototype.render = _.wrap(FacetsBrowseView.prototype.render, function(originalFn) {
		var displayOption = this.translator.options && this.translator.options.display;
		var appliedFacets = this.translator.getAllFacets();
		var itemModels = this.model.get('items').models;

		if ((appliedFacets && appliedFacets.length) || (displayOption && (displayOption === 'table' || displayOption === 'list'))) {
			this.model.get('items').models = _.filter(itemModels, function(itemModel) {
				return !itemModel.get('isPromoBanner');
			});
		} else {
			var promoBannerModel = _.find(itemModels, function(itemModel) {
				return itemModel.get('isPromoBanner') === true;
			});

			if (!promoBannerModel) {
				var plpPromoBannerConfig = getPlpPromoBannerConfig();
				var categoryModel = this.model.get('category');
				var categoryId = categoryModel && categoryModel.get('internalid');

				if (plpPromoBannerConfig && categoryId) {
					var categoryConfig = _.findWhere(plpPromoBannerConfig, { categoryId: categoryId });
					if (categoryConfig) {
						this.addPromoBannerItem(categoryConfig);
					}
				}
			}
		}

		this._render();

		applyMaxHeightToPromoImage();
	});

	FacetsItemCellView.prototype.initialize = _.wrap(FacetsItemCellView.prototype.initialize, function(originalFn) {
		originalFn.apply(this, _.toArray(arguments).slice(1));

		this.isPromoBanner = !!this.model.get('isPromoBanner');
		if (this.isPromoBanner) {
			this.template = item_cell_promo_banner_tpl;
		}
	});

	FacetsItemCellView.prototype.getContext = _.wrap(FacetsItemCellView.prototype.getContext, function(originalFn) {
		var originalContext = originalFn.apply(this, _.toArray(arguments).slice(1));
		var isPromoBanner = !!this.model.get('isPromoBanner');
		var promoBannerUrl = isPromoBanner && this.model.get('promoBannerUrl');
		var promoBlockImageLinkUrl = isPromoBanner && this.model.get('promoBlockImageLinkUrl');
		var promoBannerImageAltText = isPromoBanner && this.model.get('promoBannerImageAltText');
		var promoBlockImageLinkIsExternal = isPromoBanner && this.model.get('promoBlockImageLinkIsExternal');
		var promoBlockImageLinkNewTab = isPromoBanner && this.model.get('promoBlockImageLinkNewTab');

		return _.extend(originalContext, {
			promoBannerUrl: promoBannerUrl,
			showLink: isPromoBanner && promoBannerUrl && promoBlockImageLinkUrl,
			promoBlockImageLinkUrl: promoBlockImageLinkUrl,
			promoBannerImageAltText: promoBannerImageAltText,
			promoBlockImageLinkIsExternal: promoBlockImageLinkIsExternal,
			promoBlockImageLinkNewTab: promoBlockImageLinkNewTab
		});
	});

	return {
		mountToApp: function(container) {}
	};
});
